import { render, staticRenderFns } from "./workflow-owners.vue?vue&type=template&id=3d7034a8&scoped=true"
import script from "./workflow-owners.vue?vue&type=script&lang=js"
export * from "./workflow-owners.vue?vue&type=script&lang=js"
import style0 from "./workflow-owners.vue?vue&type=style&index=0&id=3d7034a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d7034a8",
  null
  
)

export default component.exports